import { themeAtom } from "../../shared/atoms";
import { formatDate } from "../../shared/services/utils";
import { NotificationM } from "../models/notifications.models";
import { openNotificationUrl } from "../services/notifications.service";
import { useAtomValue } from "jotai";
import React from "react";
import { useNavigate } from "react-router";
import sanitizeHtml from "sanitize-html";
import { twMerge } from "tailwind-merge";

interface Props {
  notification: NotificationM;
}

const NotificationCard: React.FC<Props> = ({ notification }) => {
  const theme = useAtomValue(themeAtom);

  const bgColor = notification.IS_READ
    ? twMerge("border-transparent", theme.headerComponent.notifications.isReadBackground)
    : twMerge(theme.uwhcAssistant.sendBorder, theme.headerComponent.notifications.itemBackground);
  const navigate = useNavigate();

  const description = sanitizeHtml(notification.DESCRIPTION, {
    allowedTags: ["b"],
  });

  return (
    <div
      className={twMerge(
        "my-2 cursor-pointer items-center rounded-lg border py-3 pl-4",
        theme.myVesselsTableRow.row.hover,
        theme.myVesselsTableRow.row.primary,
        theme.headerComponent.tailwind.buttonBorder,
        bgColor,
      )}
      onClick={() => openNotificationUrl(notification, navigate)}
    >
      <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start gap-2">
        <div className="flex flex-col items-start justify-start gap-1 self-stretch">
          <p className={twMerge("text-sm", theme.home.tailwind.textDefault)}>
            <span dangerouslySetInnerHTML={{ __html: description }} />{" "}
            <span className={twMerge("font-bold", theme.myVesselsTable.tailwind.linkText)}>{notification.CTA_TEXT}</span>
          </p>
        </div>

        {/* Date */}
        <div className={twMerge("self-stretch text-xs font-normal leading-none", theme.uwhcAssistant.text)}>
          {notification.CREATED_AT ? formatDate(notification.CREATED_AT) : "Just now"}
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
